<div class="container mt-5 mb-5">
  <router-outlet></router-outlet>
</div>
